import Request from './request';

async function addJob(data) {
    return Request('post', "api/yywd-middleware/add-job", data);
}

export default {
    addJob,
};